import { useState, useEffect, createContext, useContext, useCallback } from "react";
import axios from "axios";
import { translations as fallbackTranslations } from "@/lib/translations";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ContentContext = createContext({
  content: { hu: fallbackTranslations.hu, en: fallbackTranslations.en, updated_at: null },
  loading: true,
  refresh: () => {},
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({
    hu: fallbackTranslations.hu,
    en: fallbackTranslations.en,
    updated_at: null,
  });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent(data);
    } catch (e) {
      console.warn("Content fetch failed, using fallback", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
export { API };
